/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import { EditButton, List, TextField, BooleanField } from 'react-admin'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import ListTitle from '../../../../components/ListTitle'
import Datagrid from '../../../../components/Datagrid/Datagrid'
import Filter from '../../../../components/Filter/FilterComponents'

const useStyles = makeStyles(() => ({
    myHeader: {
        '&&:before': {
            content: '" ⇅ "',
        },
    },
    header: {
        display: 'none',
    },
}))

export default function ModulesList(props) {
    const classes = useStyles(props)
    const { quickSearch } = props
    return (
        <List
            sort={{ field: 'code', order: 'ASC' }}
            filters={<Filter {...props} />}
            {...props}
        >
            <>
                <ListTitle label="Modules" />
                <Datagrid {...props}>
                    <TextField
                        label="Code"
                        headerClassName={classes.myHeader}
                        source="code"
                    />
                    <TextField
                        label="Description"
                        headerClassName={classes.myHeader}
                        source="description"
                    />
                    <TextField
                        label="Prefix"
                        headerClassName={classes.myHeader}
                        source="prefix"
                    />
                    <BooleanField label="Display" source="is_display" />
                    {quickSearch ? (
                        <EditButton
                            headerClassName={classes.header}
                            basePath="/SS_ModuleTAB"
                        />
                    ) : (
                        <EditButton basePath="/SS_ModuleTAB" />
                    )}
                </Datagrid>
            </>
        </List>
    )
}

ModulesList.defaultProps = {
    quickSearch: false,
}
ModulesList.propTypes = {
    quickSearch: PropTypes.bool,
}
